import clsx from 'clsx'
import {toAbsoluteUrl} from '../../../../_gori/helpers'
import {Button} from '../../../../_gori/partials/widgets'
import {useIntl} from 'react-intl'

type EmptyTableProps = {
  className?: string
  imgSrc?: string
  label?: string
  CTA?: {
    title: string
    onClick: () => void
  }
}
export const EmptyTable = ({
  className = '',
  imgSrc = '/media/gori/shipments/delivery-completed.svg',
  label = 'NO_ORDER_DATA',
  CTA,
}: EmptyTableProps) => {
  const intl = useIntl()

  return (
    <div
      className={clsx(
        'd-flex flex-column flex-fill justify-content-center align-items-center',
        className
      )}
    >
      <img alt='empty' src={toAbsoluteUrl(imgSrc)} />
      <h4 className={'mt-6 txt-empty-table'}>{intl.formatMessage({id: label})}</h4>
      {!!CTA && (
        <Button
          className='btn btn-advanced-primary mt-8'
          label={intl.formatMessage({id: CTA.title})}
          event={CTA.onClick}
        />
      )}
    </div>
  )
}
